export const formatDate = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const formatCurrency = (value) => {
  const num = Number(value || 0);
  return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Maps a status string to a badge color class without using any icon glyphs.
export const statusBadgeClass = (status) => {
  const positive = ['active', 'completed', 'paid', 'verified', 'resolved', 'closed', 'reviewed', 'uploaded'];
  const warning = ['pending', 'in progress', 'waiting for client', 'under review', 'sent', 'open', 'partially paid'];
  const danger = ['inactive', 'suspended', 'locked', 'archived', 'overdue', 'rejected', 'urgent'];

  const s = String(status || '').toLowerCase();
  if (positive.includes(s)) return 'badge badge-success';
  if (warning.includes(s)) return 'badge badge-warning';
  if (danger.includes(s)) return 'badge badge-danger';
  return 'badge badge-neutral';
};
